const flexTokenize = "forward"
const flexId = "id"
const flexFields = ["title", "terms", "productId", "content"]

module.exports = {
  flexTokenize,
  flexId,
  flexFields,
};
